import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { DocsPageShell, type DocBlock } from "@/components/marketing/DocsLayout";

const blocks: DocBlock[] = [
  {
    type: "p",
    text: "The embed widget puts your twin on any website as a floating chat bubble. It's a single script tag — no framework, no build step.",
  },
  { type: "h2", text: "Install" },
  {
    type: "p",
    text: "Paste this just before the closing </body> tag on any page. Replace YOUR_TWIN_ID with your twin's ID.",
  },
  {
    type: "code",
    lang: "html",
    code: `<script src="https://realitytwin.io/api/public/embed/YOUR_TWIN_ID" async></script>`,
  },
  { type: "h2", text: "Where to find your twin ID" },
  {
    type: "p",
    text: "Your twin ID is your company ID, shown in Settings → Integrations and in your public marketplace profile URL (/marketplace/<id>). The widget only serves twins that are published.",
  },
  { type: "h2", text: "What the widget does" },
  {
    type: "ul",
    items: [
      "Loads a floating chat bubble that opens your twin's conversation.",
      "Streams grounded, cited answers from your knowledge base.",
      "Captures name and email in-conversation when a visitor shows intent.",
      "Works on any stack — plain HTML, WordPress, Webflow, Shopify, React, etc.",
    ],
  },
  { type: "h2", text: "Full-page & API options" },
  {
    type: "p",
    text: "Prefer a dedicated page? Every twin also has a full-page chat at /embed/<companyId>. For custom UIs, the same conversation runs over the chat endpoint at /api/chat.",
  },
  {
    type: "callout",
    title: "Abuse protection",
    text: "The public embed and chat endpoints are rate-limited per IP and fail closed with clean errors, so a burst of traffic can't run up your usage or crash the widget.",
  },
  { type: "h2", text: "Usage & metering" },
  {
    type: "p",
    text: "Widget conversations draw from your account's shared monthly conversation pool, the same as every other surface. See Plans & usage for limits.",
  },
];

export const Route = createFileRoute("/docs/embed-widget")({
  head: () =>
    buildSeo({
      path: "/docs/embed-widget",
      title: "Embed Widget — Reality Twin Docs",
      description:
        "Add your AI Twin to any website with one script tag. Install, twin ID, and options.",
    }),
  component: () => (
    <DocsPageShell
      slug="embed-widget"
      title="Embed widget"
      description="Add the chat widget to any website with one script tag."
      blocks={blocks}
    />
  ),
});
